<input #input_search_boards (keyup)="0" (keyup.esc)="onClose()" [focus]="true" placeholder="Search Boards...">
<div class="items_container">
  <p *ngFor="let board of allBoards$ | async | searchByField: 'name': input_search_boards.value"
     (click)="onSelectBoard(board)">
    {{board.name}}
    <span *ngIf="checkSelectedBoard[board.id]" class="select_marker"></span>
  </p>
</div>
